/** Assembles PlanPage header + rail props (lint split from PlanPage). */
import { PlanPageHeader } from '@/features/planning/pages/PlanPageHeader';
import { buildPlanPageHeaderLabels } from '@/features/planning/pages/planPageHeaderLabels';
import { buildPlanTabs } from '@/features/planning/pages/planPageLayoutHelpers';

export function buildPlanPageHeaderAndRail({
  t,
  isBattlefield,
  activeView,
  setPlanView,
  planMode,
  canUsePlanMode,
  onTogglePlanMode,
  isAgendaEnabled,
  canUseAgenda,
  showAgendaToggle,
  handleToggleAgenda,
  syncStatus,
  overdueTasks,
  nextActions,
  unscheduledTasks,
  overdueRailSlice,
  nextActionRailSlice,
  selectedTaskIds,
  railSelectionHandlers,
  focusOwnerId,
  renderView,
  planRailTasks,
  plannedParentIds,
  waitingForParentIds,
  tasksMap,
  welcomePlanTour,
}) {
  const labels = buildPlanPageHeaderLabels(t, {
    canUsePlanMode,
    planMode,
    isAgendaEnabled,
    canUseAgenda,
  });
  const railProps = {
    overdueTasks,
    nextActions,
    unscheduledTasks,
    overdueRailSlice,
    nextActionRailSlice,
    selectedTaskIds,
    railSelectionHandlers,
    focusOwnerId,
    renderView,
    planMode,
    planRailTasks,
    plannedParentIds,
    waitingForParentIds,
    tasksMap,
    onboardingHighlightTaskId: welcomePlanTour.slotHighlightTaskId,
    onboardingHighlightAddTask: welcomePlanTour.highlightAddTask,
    onOnboardingAddTaskUsed: welcomePlanTour.onAddTaskHighlightUsed,
  };
  const planHeader = (
    <PlanPageHeader
      tabs={buildPlanTabs(t, isBattlefield)}
      activeView={activeView}
      onTabChange={(_, v) => setPlanView(v)}
      planMode={planMode}
      canUsePlanMode={canUsePlanMode}
      onTogglePlanMode={onTogglePlanMode}
      isAgendaEnabled={isAgendaEnabled}
      canUseAgenda={canUseAgenda}
      showAgendaToggle={showAgendaToggle}
      onToggleAgenda={handleToggleAgenda}
      syncStatus={syncStatus}
      {...labels}
    />
  );
  return { planHeader, railProps };
}
